import { SET_CHANGE_NAVIGATION } from "./actions.type";
import { NavigationState, SetChangeNavigation } from "./types";

const initialState: NavigationState = {
  navigation: undefined,
};

export default (state = initialState, action: SetChangeNavigation): NavigationState => {
  switch (action.type) {
    case SET_CHANGE_NAVIGATION:
      return {
        ...state,
        navigation: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
